import React from 'react';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { 
  Ship, 
  Plane, 
  GraduationCap,
  Palmtree,
  Receipt,
  Briefcase,
  FileCheck
} from 'lucide-react';

// Trip types array - sorted alphabetically by label
const tripTypes = [
  { value: 'work_trip', label: 'At Sea/On Vessel', icon: Ship },
  { value: 'base_work_foreign', label: 'Base Work (Abroad)', icon: Briefcase },
  { value: 'base_work_uk', label: 'Base Work (UK)', icon: Briefcase },
  { value: 'course_foreign', label: 'Course (Abroad)', icon: GraduationCap },
  { value: 'course_uk', label: 'Course (UK)', icon: GraduationCap },
  { value: 'paid_leave', label: 'Paid Annual Leave', icon: Palmtree },
  { value: 'qualifying_holiday', label: 'Qualifying Holiday', icon: Plane },
  { value: 'visa_run', label: 'Visa Run', icon: FileCheck },
  { value: 'wage_adjustment', label: 'Wage Adjustment', icon: Receipt },
].sort((a, b) => a.label.localeCompare(b.label));

const TripTypeSelector = ({ value, onChange }) => {
  return (
    <div className="space-y-2">
      <Label className="text-slate-300">Trip Type</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="trip-type-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-slate-800 border-slate-600">
          {tripTypes.map((type) => {
            const Icon = type.icon;
            return (
              <SelectItem 
                key={type.value} 
                value={type.value} 
                className="text-white hover:bg-slate-700"
              >
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  {type.label}
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TripTypeSelector;
